import { render, staticRenderFns } from "./MoveCustomerToStaff.vue?vue&type=template&id=1a77ddd3&scoped=true&"
import script from "./MoveCustomerToStaff.vue?vue&type=script&lang=js&"
export * from "./MoveCustomerToStaff.vue?vue&type=script&lang=js&"
import style0 from "./MoveCustomerToStaff.vue?vue&type=style&index=0&id=1a77ddd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a77ddd3",
  null
  
)

export default component.exports